(function() {
  function injectIcerikHtml() {
    document.querySelectorAll('textarea.product__icerik-html-src').forEach(function(ta) {
      var tid = ta.getAttribute('data-icerik-target');
      var el = tid && document.getElementById(tid);
      if (!el || el.dataset.icerikInjected) return;
      try {
        var html = JSON.parse(ta.value);
        if (typeof html === 'string') {
          el.innerHTML = html;
          el.dataset.icerikInjected = '1';
          ta.remove();
        }
      } catch (err) {}
    });
  }

  injectIcerikHtml();

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.product__fayda-details')) {
      document.querySelectorAll('.product__fayda-details[open]').forEach(function(d) {
        d.removeAttribute('open');
      });
    }
  });

  document.addEventListener('toggle', function(e) {
    var t = e.target;
    if (!t || t.tagName !== 'DETAILS' || !t.classList.contains('product__fayda-details')) return;
    if (!t.open) return;
    
    document.querySelectorAll('.product__fayda-details[open]').forEach(function(d) {
      if (d !== t) d.removeAttribute('open');
    });

    var desc = t.querySelector('.product__fayda-description');
    if (!desc) return;

    if (window.innerWidth >= 1200) {
      desc.style.transform = '';
      desc.style.transition = '';
      desc.style.opacity = '';
      return;
    }

    desc.style.transition = 'none';
    desc.style.opacity = '0';
    desc.style.transform = 'translateX(-50%) translateY(-4px)';

    setTimeout(function() {
      var rect = desc.getBoundingClientRect();
      var vw = document.documentElement.clientWidth;
      var pad = 12;
      var shift = 0;

      if (rect.left < pad) {
        shift = pad - rect.left;
      } else if (rect.right > vw - pad) {
        shift = (vw - pad) - rect.right;
      }

      desc.style.transition = 'transform 0.25s ease-out, opacity 0.25s ease-out';
      desc.style.opacity = '1';
      var finalTransform = 'translateX(calc(-50% + ' + Math.round(shift) + 'px)) translateY(0)';
      desc.style.transform = finalTransform;
    }, 30);
  }, true);

  function _noScroll(e) {
    if (document.querySelector('.product__review-lightbox.is-open')) {
      e.preventDefault();
      return;
    }
    if (e.target.closest('.product__accordion-panel-body')) return;
    e.preventDefault();
  }

  var scrollLockCount = 0;
  var scrollLockState = null;
  var pendingDrawerScrollY = null;

  document.addEventListener(
    'mousedown',
    function(e) {
      if (e.target.closest('[data-open-reviews-drawer], .product__accordion-trigger')) {
        pendingDrawerScrollY = window.scrollY || window.pageYOffset || 0;
      }
    },
    true
  );

  document.addEventListener(
    'touchstart',
    function(e) {
      if (e.target.closest('[data-open-reviews-drawer], .product__accordion-trigger')) {
        pendingDrawerScrollY = window.scrollY || window.pageYOffset || 0;
      }
    },
    { capture: true, passive: true }
  );

  function _lockScroll() {
    scrollLockCount += 1;
    if (scrollLockCount > 1) return;

    var scrollY =
      pendingDrawerScrollY != null ? pendingDrawerScrollY : window.scrollY || window.pageYOffset || 0;
    pendingDrawerScrollY = null;
    var sbw = window.innerWidth - document.documentElement.clientWidth;

    scrollLockState = { scrollY: scrollY };

    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.documentElement.classList.add('product-scroll-locked');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    document.addEventListener('wheel', _noScroll, { passive: false });
    document.addEventListener('touchmove', _noScroll, { passive: false });
  }

  function _unlockScroll() {
    if (scrollLockCount <= 0) return;
    scrollLockCount -= 1;
    if (scrollLockCount > 0) return;

    var scrollY = scrollLockState ? scrollLockState.scrollY : 0;
    scrollLockState = null;

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.paddingRight = '';
    document.documentElement.classList.remove('product-scroll-locked');

    document.removeEventListener('wheel', _noScroll);
    document.removeEventListener('touchmove', _noScroll);

    window.scrollTo(0, scrollY);
  }

  var DRAWER_CLOSE_STACK_MS = 320;

  function clearDrawerCloseTimer(drawer) {
    if (drawer._dlCloseTimer) {
      clearTimeout(drawer._dlCloseTimer);
      drawer._dlCloseTimer = null;
    }
  }

  function beginDrawerClose(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    clearDrawerCloseTimer(drawer);
    var portal = drawer.querySelector('.product__accordion-portal');
    var trigger = drawer.querySelector('.product__accordion-trigger');

    drawer.classList.add('is-closing');
    drawer.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (portal) portal.setAttribute('aria-hidden', 'true');
    if (drawer.id === 'product-reviews-drawer') {
      var reviewsBtn = document.querySelector('[data-open-reviews-drawer]');
      if (reviewsBtn) reviewsBtn.setAttribute('aria-expanded', 'false');
      if (typeof window.closeProductReviewLightbox === 'function') window.closeProductReviewLightbox();
    }

    drawer._dlCloseTimer = setTimeout(function() {
      drawer.classList.remove('is-closing');
      drawer._dlCloseTimer = null;
    }, DRAWER_CLOSE_STACK_MS);

    if (!document.querySelector('.product__accordion-drawer.is-open')) {
      _unlockScroll();
    }
  }

  function forceShutDrawer(drawer) {
    if (!drawer) return;
    clearDrawerCloseTimer(drawer);
    drawer.classList.remove('is-open', 'is-closing');
    var tr = drawer.querySelector('.product__accordion-trigger');
    if (tr) tr.setAttribute('aria-expanded', 'false');
    var portal = drawer.querySelector('.product__accordion-portal');
    if (portal) portal.setAttribute('aria-hidden', 'true');
    if (drawer.id === 'product-reviews-drawer') {
      var reviewsBtn = document.querySelector('[data-open-reviews-drawer]');
      if (reviewsBtn) reviewsBtn.setAttribute('aria-expanded', 'false');
      if (typeof window.closeProductReviewLightbox === 'function') window.closeProductReviewLightbox();
    }
  }

  function closeAllProductDrawers() {
    document.querySelectorAll('.product__accordion-drawer.is-open').forEach(function(root) {
      beginDrawerClose(root);
    });
    if (!document.querySelector('.product__accordion-drawer.is-open')) {
      _unlockScroll();
    }
  }

  function openProductDrawer(root) {
    document.querySelectorAll('.product__accordion-drawer').forEach(function(d) {
      if (d !== root) forceShutDrawer(d);
    });
    root.classList.remove('is-closing');
    clearDrawerCloseTimer(root);
    _lockScroll();
    root.classList.add('is-open');
    var tr = root.querySelector('.product__accordion-trigger');
    if (tr) tr.setAttribute('aria-expanded', 'true');
    var portal = root.querySelector('.product__accordion-portal');
    if (portal) portal.setAttribute('aria-hidden', 'false');
    var closeBtn = root.querySelector('.product__accordion-close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
    injectIcerikHtml();
  }

  document.addEventListener('click', function(e) {
    var reviewsBtn = e.target.closest('[data-open-reviews-drawer]');
    if (reviewsBtn) {
      var reviewsDrawer = document.getElementById('product-reviews-drawer');
      if (!reviewsDrawer) return;
      e.preventDefault();
      if (reviewsDrawer.classList.contains('is-open')) {
        beginDrawerClose(reviewsDrawer);
        reviewsBtn.setAttribute('aria-expanded', 'false');
        reviewsBtn.focus({ preventScroll: true });
        return;
      }
      openProductDrawer(reviewsDrawer);
      reviewsBtn.setAttribute('aria-expanded', 'true');
      if (typeof loadProductReviews === 'function') loadProductReviews();
      return;
    }

    var trigger = e.target.closest('.product__accordion-trigger');
    if (trigger) {
      var root = trigger.closest('.product__accordion-drawer');
      if (!root) return;
      e.preventDefault();
      if (root.classList.contains('is-open')) {
        beginDrawerClose(root);
        return;
      }
      openProductDrawer(root);
      return;
    }
    if (e.target.closest('[data-close-drawer]')) {
      var closeEl = e.target.closest('[data-close-drawer]');
      var root = closeEl && closeEl.closest('.product__accordion-drawer');
      if (root) {
        beginDrawerClose(root);
        var t = root.querySelector('.product__accordion-trigger');
        if (t) {
          t.focus({ preventScroll: true });
        } else if (root.id === 'product-reviews-drawer') {
          var reviewsBtn = document.querySelector('[data-open-reviews-drawer]');
          if (reviewsBtn) {
            reviewsBtn.setAttribute('aria-expanded', 'false');
            reviewsBtn.focus({ preventScroll: true });
          }
        }
      }
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    if (typeof window.closeProductReviewLightbox === 'function' && window.closeProductReviewLightbox()) return;
    var open = document.querySelector('.product__accordion-drawer.is-open');
    if (!open) return;
    beginDrawerClose(open);
    var tr = open.querySelector('.product__accordion-trigger');
    if (tr) {
      tr.focus({ preventScroll: true });
    } else if (open.id === 'product-reviews-drawer') {
      var reviewsBtn = document.querySelector('[data-open-reviews-drawer]');
      if (reviewsBtn) {
        reviewsBtn.setAttribute('aria-expanded', 'false');
        reviewsBtn.focus({ preventScroll: true });
      }
    }
  });

  (function initProductReviews() {
    var drawer = document.getElementById('product-reviews-drawer');
    if (!drawer) return;

    var API_BASE = 'https://tasarlab-shopify-app.vercel.app/api/reviews';
    var LIMIT = 200;
    var CACHE_TTL = 5 * 60 * 1000;
    var productId = drawer.getAttribute('data-product-id');
    var listEl = drawer.querySelector('[data-product-reviews-list]');
    var toolbarEl = drawer.querySelector('[data-product-reviews-toolbar]');
    var searchInput = drawer.querySelector('[data-reviews-search]');
    var sortDetailsEl = drawer.querySelector('[data-reviews-sort-details]');
    var sortPanelWrap = sortDetailsEl
      ? sortDetailsEl.querySelector('[data-reviews-sort-panel-wrap]')
      : null;
    var sortSummaryEl = sortDetailsEl
      ? sortDetailsEl.querySelector('.product__reviews-sort-btn')
      : null;
    var sortLabelEl = drawer.querySelector('[data-reviews-sort-label]');
    var sortOptionEls = drawer.querySelectorAll('[data-reviews-sort]');
    var titleEl = document.getElementById('product-reviews-drawer-title');
    var reviewsLink = document.querySelector('[data-open-reviews-drawer]');
    var lightboxEl = document.getElementById('product-review-lightbox');
    var lightboxImageEl = lightboxEl ? lightboxEl.querySelector('.product__review-lightbox-image') : null;
    var cache = null;
    var fetchPromise = null;
    var searchTimer = null;
    var viewState = { sort: 'recommended', query: '' };
    var minRating = parseInt(drawer.getAttribute('data-reviews-min-rating') || '0', 10);
    if (isNaN(minRating) || minRating < 1) minRating = 0;
    var starIconUrl = drawer.getAttribute('data-reviews-star-icon') || '';

    var sortLabels = {
      recommended: drawer.getAttribute('data-reviews-sort-recommended') || 'Recommended',
      newest: drawer.getAttribute('data-reviews-sort-newest') || 'Newest first',
      oldest: drawer.getAttribute('data-reviews-sort-oldest') || 'Oldest first',
      rating_asc: drawer.getAttribute('data-reviews-sort-rating-asc') || 'Lowest rating',
      rating_desc: drawer.getAttribute('data-reviews-sort-rating-desc') || 'Highest rating'
    };

    var i18n = {
      title: drawer.getAttribute('data-reviews-title') || '',
      loading: drawer.getAttribute('data-reviews-loading') || 'Loading…',
      empty: drawer.getAttribute('data-reviews-empty') || '',
      error: drawer.getAttribute('data-reviews-error') || '',
      searchEmpty: drawer.getAttribute('data-reviews-search-empty') || 'No reviews match your search.',
      ratingAria: drawer.getAttribute('data-reviews-rating-aria') || '{{ rating }} / 5',
      anonymous: drawer.getAttribute('data-reviews-anonymous') || 'Anonymous',
      imageOpen: drawer.getAttribute('data-reviews-image-open') || 'Enlarge photo'
    };

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function formatReviewDate(iso) {
      if (!iso) return '';
      try {
        return new Intl.DateTimeFormat(document.documentElement.lang || 'tr', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        }).format(new Date(iso));
      } catch (err) {
        return iso;
      }
    }

    function isAnonymousAuthor(name) {
      var raw = String(name || '').trim();
      if (!raw) return false;
      return /^[\*\s]+$/.test(raw);
    }

    function formatAuthor(author) {
      if (!author) return '';
      if (isAnonymousAuthor(author)) return escapeHtml(i18n.anonymous);
      var raw = String(author).trim();
      return raw
        .split(/(\*+)/)
        .map(function(part) {
          if (!part) return '';
          if (/^\*+$/.test(part)) {
            return (
              '<span class="product__review-author-mask">' + escapeHtml(part) + '</span>'
            );
          }
          return escapeHtml(part);
        })
        .join('');
    }

    function getAuthorInitial(author) {
      if (!author) return '?';
      if (isAnonymousAuthor(author)) return 'A';
      var match = String(author).trim().match(/[A-Za-zğüşıöçĞÜŞİÖÇ]/);
      return match ? match[0].toLocaleUpperCase('tr-TR') : '?';
    }

    function renderStars(rating) {
      var safeRating = Math.max(0, Math.min(5, Number(rating) || 0));
      var aria = i18n.ratingAria.replace('{{ rating }}', String(safeRating));
      var html =
        '<div class="product__review-stars" role="img" aria-label="' + escapeHtml(aria) + '">';
      for (var i = 1; i <= 5; i++) {
        html +=
          '<span class="product__review-star' +
          (i <= safeRating ? ' is-filled' : '') +
          '" aria-hidden="true">' +
          '<img src="' +
          escapeHtml(starIconUrl) +
          '" alt="" width="16" height="16" loading="lazy" decoding="async" class="product__review-star-icon">' +
          '</span>';
      }
      html += '</div>';
      return html;
    }

    function renderImages(images) {
      if (!images || !images.length) return '';
      var html = '<ul class="product__review-images" role="list">';
      images.forEach(function(image) {
        var src = image && image.public_url;
        if (!src) return;
        html +=
          '<li class="product__review-images-item">' +
          '<button type="button" class="product__review-image-btn" data-review-image-open data-review-image-src="' +
          escapeHtml(src) +
          '" aria-label="' +
          escapeHtml(i18n.imageOpen) +
          '">' +
          '<img src="' +
          escapeHtml(src) +
          '" alt="" width="72" height="72" loading="lazy" decoding="async" class="product__review-image">' +
          '</button>' +
          '</li>';
      });
      html += '</ul>';
      return html;
    }

    function openReviewLightbox(src) {
      if (!lightboxEl || !lightboxImageEl || !src) return;
      lightboxImageEl.src = src;
      lightboxEl.hidden = false;
      lightboxEl.classList.add('is-open');
      document.documentElement.classList.add('product-review-lightbox-open');
      var closeBtn = lightboxEl.querySelector('.product__review-lightbox-close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function closeReviewLightbox() {
      if (!lightboxEl || lightboxEl.hidden) return false;
      lightboxEl.hidden = true;
      lightboxEl.classList.remove('is-open');
      document.documentElement.classList.remove('product-review-lightbox-open');
      if (lightboxImageEl) lightboxImageEl.removeAttribute('src');
      return true;
    }

    window.closeProductReviewLightbox = closeReviewLightbox;

    if (listEl) {
      listEl.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-review-image-open]');
        if (!btn || !listEl.contains(btn)) return;
        e.preventDefault();
        openReviewLightbox(btn.getAttribute('data-review-image-src'));
      });
    }

    if (lightboxEl) {
      lightboxEl.addEventListener('click', function(e) {
        if (e.target.closest('[data-review-lightbox-close]')) {
          e.preventDefault();
          closeReviewLightbox();
        }
      });
    }

    function updateCounts(total) {
      if (titleEl) {
        titleEl.textContent = total > 0 ? i18n.title + ' (' + total + ')' : i18n.title;
      }
      if (reviewsLink && total > 0) {
        var base =
          reviewsLink.getAttribute('data-reviews-link-base') ||
          reviewsLink.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
        reviewsLink.setAttribute('data-reviews-link-base', base);
        reviewsLink.textContent = base + ' (' + total + ')';
      }
    }

    function getReviewDate(review) {
      return review.review_date ? new Date(review.review_date).getTime() : 0;
    }

    function getReviewRating(review) {
      return Math.max(0, Math.min(5, Number(review.rating) || 0));
    }

    function hasReviewImages(review) {
      return (
        review.images &&
        review.images.some(function(image) {
          return image && image.public_url;
        })
      );
    }

    function hasReviewComment(review) {
      var comment = review.comment && String(review.comment).trim();
      var title = review.title && String(review.title).trim();
      return !!(comment || title);
    }

    function getReviewSortTier(review) {
      if (hasReviewImages(review)) return 0;
      if (hasReviewComment(review)) return 1;
      return 2;
    }

    function sortReviews(reviews, sortKey) {
      var key = sortKey || viewState.sort || 'recommended';
      return reviews.slice().sort(function(a, b) {
        if (key === 'recommended') {
          var tierDiff = getReviewSortTier(a) - getReviewSortTier(b);
          if (tierDiff !== 0) return tierDiff;
          return getReviewDate(b) - getReviewDate(a);
        }
        if (key === 'newest') return getReviewDate(b) - getReviewDate(a);
        if (key === 'oldest') return getReviewDate(a) - getReviewDate(b);
        if (key === 'rating_asc') {
          var ratingDiff = getReviewRating(a) - getReviewRating(b);
          if (ratingDiff !== 0) return ratingDiff;
          return getReviewDate(b) - getReviewDate(a);
        }
        if (key === 'rating_desc') {
          var ratingDiffDesc = getReviewRating(b) - getReviewRating(a);
          if (ratingDiffDesc !== 0) return ratingDiffDesc;
          return getReviewDate(b) - getReviewDate(a);
        }
        return 0;
      });
    }

    function filterReviewsByRating(reviews) {
      if (!minRating) return reviews.slice();
      return reviews.filter(function(review) {
        return getReviewRating(review) >= minRating;
      });
    }

    function filterReviews(reviews) {
      var query = String(viewState.query || '').trim().toLowerCase();
      if (!query) return reviews.slice();
      return reviews.filter(function(review) {
        var haystack = [review.comment, review.title, review.author]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        return haystack.indexOf(query) !== -1;
      });
    }

    function setToolbarVisible(visible) {
      if (!toolbarEl) return;
      if (visible) toolbarEl.removeAttribute('hidden');
      else toolbarEl.setAttribute('hidden', '');
    }

    function updateSortUi() {
      var label = sortLabels[viewState.sort] || sortLabels.recommended;
      if (sortLabelEl) sortLabelEl.textContent = label;
      sortOptionEls.forEach(function(option) {
        var isActive = option.getAttribute('data-reviews-sort') === viewState.sort;
        option.classList.toggle('is-active', isActive);
      });
    }

    function renderReviewCard(review) {
      var author = formatAuthor(review.author);
      var authorInitial = getAuthorInitial(review.author);
      var comment = review.comment ? escapeHtml(review.comment) : '';
      var title = review.title ? escapeHtml(review.title) : '';
      var dateIso = review.review_date || '';
      var dateText = formatReviewDate(dateIso);
      var html = '<li class="product__review-item"><article class="product__review-card">';
      html += '<header class="product__review-card-header">';
      html += '<div class="product__review-meta">';
      html += '<span class="product__review-avatar" aria-hidden="true">' + escapeHtml(authorInitial) + '</span>';
      html += '<div class="product__review-meta-text">';
      if (author) {
        html += '<p class="product__review-author">' + author + '</p>';
      }
      if (dateIso) {
        html += '<time class="product__review-date" datetime="' + escapeHtml(dateIso) + '">';
        html += escapeHtml(dateText);
        html += '</time>';
      }
      html += '</div></div>';
      html += '<div class="product__review-rating">' + renderStars(review.rating) + '</div>';
      html += '</header>';

      if (title || comment || (review.images && review.images.length)) {
        html += '<div class="product__review-body">';
        if (title) {
          html += '<p class="product__review-title">' + title + '</p>';
        }
        if (comment) {
          html += '<p class="product__review-comment">' + comment + '</p>';
        }
        html += renderImages(review.images);
        html += '</div>';
      }

      html += '</article></li>';
      return html;
    }

    function renderReviews(reviews, meta) {
      var ratedReviews = filterReviewsByRating(reviews);
      var displayTotal = ratedReviews.length;
      updateCounts(displayTotal);

      if (!reviews.length) {
        setToolbarVisible(false);
        listEl.innerHTML = '<p class="product__reviews-empty">' + escapeHtml(i18n.empty) + '</p>';
        return;
      }

      if (!displayTotal) {
        setToolbarVisible(false);
        listEl.innerHTML = '<p class="product__reviews-empty">' + escapeHtml(i18n.empty) + '</p>';
        return;
      }

      setToolbarVisible(true);
      updateSortUi();

      var filtered = filterReviews(ratedReviews);
      if (!filtered.length) {
        listEl.innerHTML =
          '<p class="product__reviews-empty">' + escapeHtml(i18n.searchEmpty) + '</p>';
        return;
      }

      var sorted = sortReviews(filtered, viewState.sort);
      var html = '<ul class="product__reviews-list" role="list">';
      sorted.forEach(function(review) {
        html += renderReviewCard(review);
      });
      html += '</ul>';
      listEl.innerHTML = html;
    }

    function showLoading() {
      setToolbarVisible(false);
      listEl.innerHTML =
        '<p class="product__reviews-loading">' + escapeHtml(i18n.loading) + '</p>';
    }

    function showError() {
      setToolbarVisible(false);
      listEl.innerHTML = '<p class="product__reviews-error">' + escapeHtml(i18n.error) + '</p>';
    }

    function fetchReviews(force) {
      if (!productId || !listEl) return Promise.resolve();

      if (!force && cache && Date.now() - cache.at < CACHE_TTL) {
        renderReviews(cache.reviews, cache.meta);
        return Promise.resolve(cache);
      }

      if (fetchPromise) return fetchPromise;

      showLoading();

      var url = new URL(API_BASE);
      url.searchParams.set('shopify_product_id', String(productId));
      url.searchParams.set('limit', String(LIMIT));

      fetchPromise = fetch(url.toString())
        .then(function(response) {
          if (!response.ok) throw new Error('Reviews API ' + response.status);
          return response.json();
        })
        .then(function(data) {
          cache = {
            reviews: Array.isArray(data.reviews) ? data.reviews : [],
            meta: data.meta || { total: 0, limit: LIMIT },
            at: Date.now()
          };
          renderReviews(cache.reviews, cache.meta);
          return cache;
        })
        .catch(function() {
          showError();
          return null;
        })
        .finally(function() {
          fetchPromise = null;
        });

      return fetchPromise;
    }

    window.loadProductReviews = function(force) {
      return fetchReviews(!!force);
    };

    var SORT_DROPDOWN_MS = 220;
    var SORT_DROPDOWN_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

    function sortDropdownReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function afterSortDropdownTransition(wrap, cb) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        wrap.removeEventListener('transitionend', onEnd);
        cb();
      }
      function onEnd(e) {
        if (e.target !== wrap || e.propertyName !== 'height') return;
        finish();
      }
      wrap.addEventListener('transitionend', onEnd);
      window.setTimeout(finish, SORT_DROPDOWN_MS + 80);
    }

    function closeSortDropdown(onDone) {
      if (!sortDetailsEl || !sortPanelWrap || !sortDetailsEl.open) {
        if (onDone) onDone();
        return;
      }

      if (sortDropdownReducedMotion()) {
        sortPanelWrap.style.transition = '';
        sortPanelWrap.style.height = '';
        sortPanelWrap.style.overflow = '';
        sortDetailsEl.open = false;
        if (onDone) onDone();
        return;
      }

      var height = sortPanelWrap.scrollHeight;
      if (height < 1) {
        sortPanelWrap.style.transition = '';
        sortPanelWrap.style.height = '';
        sortPanelWrap.style.overflow = '';
        sortDetailsEl.open = false;
        if (onDone) onDone();
        return;
      }

      sortPanelWrap.style.overflow = 'hidden';
      sortPanelWrap.style.height = height + 'px';
      sortPanelWrap.style.transition = 'height ' + SORT_DROPDOWN_MS + 'ms ' + SORT_DROPDOWN_EASING;
      void sortPanelWrap.offsetHeight;
      sortPanelWrap.style.height = '0px';

      afterSortDropdownTransition(sortPanelWrap, function() {
        sortPanelWrap.style.transition = '';
        sortPanelWrap.style.height = '';
        sortPanelWrap.style.overflow = '';
        sortDetailsEl.open = false;
        if (onDone) onDone();
      });
    }

    function openSortDropdown(onDone) {
      if (!sortDetailsEl || !sortPanelWrap) {
        if (onDone) onDone();
        return;
      }

      if (sortDropdownReducedMotion()) {
        sortDetailsEl.open = true;
        sortPanelWrap.style.transition = '';
        sortPanelWrap.style.height = '';
        sortPanelWrap.style.overflow = '';
        if (onDone) onDone();
        return;
      }

      sortPanelWrap.style.overflow = 'hidden';
      sortPanelWrap.style.height = '0px';
      sortDetailsEl.open = true;
      var targetHeight = Math.max(sortPanelWrap.scrollHeight, 1);
      sortPanelWrap.style.transition = 'height ' + SORT_DROPDOWN_MS + 'ms ' + SORT_DROPDOWN_EASING;
      void sortPanelWrap.offsetHeight;
      sortPanelWrap.style.height = targetHeight + 'px';

      afterSortDropdownTransition(sortPanelWrap, function() {
        sortPanelWrap.style.transition = '';
        if (sortDetailsEl.open) sortPanelWrap.style.height = 'auto';
        else sortPanelWrap.style.height = '';
        sortPanelWrap.style.overflow = '';
        if (onDone) onDone();
      });
    }

    if (sortSummaryEl && sortPanelWrap) {
      sortSummaryEl.addEventListener('click', function(e) {
        e.preventDefault();
        if (sortDetailsEl.open) closeSortDropdown();
        else openSortDropdown();
      });
    }

    document.addEventListener('click', function(e) {
      if (!sortDetailsEl || !sortDetailsEl.open) return;
      if (sortDetailsEl.contains(e.target)) return;
      closeSortDropdown();
    });

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function() {
          viewState.query = searchInput.value;
          if (cache) renderReviews(cache.reviews, cache.meta);
        }, 200);
      });
    }

    drawer.addEventListener('click', function(e) {
      var sortBtn = e.target.closest('[data-reviews-sort]');
      if (!sortBtn || !drawer.contains(sortBtn)) return;
      e.preventDefault();
      viewState.sort = sortBtn.getAttribute('data-reviews-sort') || 'recommended';
      updateSortUi();
      closeSortDropdown();
      if (cache) renderReviews(cache.reviews, cache.meta);
    });

    fetchReviews(false);
  })();

  var galleryRoot = document.querySelector('.product__gallery-mobile');
  var galleryTrack = document.getElementById('product-gallery-track');
  var gallerySlider = galleryRoot ? galleryRoot.querySelector('[data-product-gallery-slider]') : null;

  if (galleryRoot && galleryTrack && gallerySlider) {
    var thumbButtons = galleryRoot.querySelectorAll('.product__gallery-thumb');
    var slideCount = thumbButtons.length;

    if (slideCount > 1) {
      var firstSlide = galleryTrack.querySelector('.product__gallery-slide');
      var lastSlide = galleryTrack.querySelector('.product__gallery-slide:last-child');
      var cloneFirst = firstSlide ? firstSlide.cloneNode(true) : null;
      var cloneLast = lastSlide ? lastSlide.cloneNode(true) : null;

      if (cloneFirst) {
        cloneFirst.classList.add('product__gallery-slide--clone');
        galleryTrack.appendChild(cloneFirst);
      }
      if (cloneLast) {
        cloneLast.classList.add('product__gallery-slide--clone');
        galleryTrack.insertBefore(cloneLast, galleryTrack.firstChild);
      }

      var displayIndex = 1;
      var isAnimating = false;
      var swipeThreshold = 50;
      var swipeStartX = 0;
      var swipeStartY = 0;
      var swipeTracking = false;
      var dragStartX = 0;
      var dragStartDisplayIndex = 1;
      var isDragging = false;
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function getRealIndex(index) {
        if (index === 0) return slideCount - 1;
        if (index === slideCount + 1) return 0;
        return index - 1;
      }

      function syncThumbs(realIndex) {
        thumbButtons.forEach(function(btn, i) {
          var isActive = i === realIndex;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        var activeBtn = thumbButtons[realIndex];
        if (activeBtn) {
          activeBtn.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
        }
      }

      function setTrackPosition(index, animate) {
        galleryTrack.classList.toggle('is-dragging', !animate || prefersReducedMotion);
        galleryTrack.style.transform = 'translate3d(-' + index * 100 + '%, 0, 0)';
      }

      function goToDisplayIndex(index, animate) {
        if (isAnimating && animate) return;

        var changed = displayIndex !== index;
        displayIndex = index;
        setTrackPosition(displayIndex, animate);
        syncThumbs(getRealIndex(displayIndex));

        if (!animate || prefersReducedMotion || !changed) {
          if (!animate || prefersReducedMotion) handleLoopSnap();
          isAnimating = false;
          return;
        }

        isAnimating = true;
      }

      function handleLoopSnap() {
        if (displayIndex === 0) {
          displayIndex = slideCount;
          setTrackPosition(displayIndex, false);
          syncThumbs(getRealIndex(displayIndex));
        } else if (displayIndex === slideCount + 1) {
          displayIndex = 1;
          setTrackPosition(displayIndex, false);
          syncThumbs(getRealIndex(displayIndex));
        }
        isAnimating = false;
      }

      function goToRealIndex(realIndex, animate) {
        goToDisplayIndex(realIndex + 1, animate);
      }

      function goNext() {
        goToDisplayIndex(displayIndex + 1, true);
      }

      function goPrev() {
        goToDisplayIndex(displayIndex - 1, true);
      }

      galleryTrack.addEventListener('transitionend', function(e) {
        if (e.target !== galleryTrack || e.propertyName !== 'transform') return;
        handleLoopSnap();
      });

      thumbButtons.forEach(function(btn, index) {
        btn.addEventListener('click', function() {
          if (getRealIndex(displayIndex) === index) return;
          goToRealIndex(index, true);
        });
      });

      gallerySlider.addEventListener(
        'touchstart',
        function(e) {
          if (!e.touches || e.touches.length !== 1 || isAnimating) return;
          swipeStartX = e.touches[0].clientX;
          swipeStartY = e.touches[0].clientY;
          dragStartX = swipeStartX;
          dragStartDisplayIndex = displayIndex;
          swipeTracking = true;
          isDragging = false;
        },
        { passive: true }
      );

      gallerySlider.addEventListener(
        'touchmove',
        function(e) {
          if (!swipeTracking || !e.touches || e.touches.length !== 1 || isAnimating) return;

          var currentX = e.touches[0].clientX;
          var currentY = e.touches[0].clientY;
          var deltaX = currentX - swipeStartX;
          var deltaY = currentY - swipeStartY;

          if (!isDragging) {
            if (Math.abs(deltaX) < 8 && Math.abs(deltaY) < 8) return;
            if (Math.abs(deltaY) > Math.abs(deltaX)) {
              swipeTracking = false;
              return;
            }
            isDragging = true;
          }

          var slideWidth = gallerySlider.offsetWidth || 1;
          var dragOffsetPercent = ((currentX - dragStartX) / slideWidth) * 100;
          galleryTrack.classList.add('is-dragging');
          galleryTrack.style.transform =
            'translate3d(' + (-dragStartDisplayIndex * 100 + dragOffsetPercent) + '%, 0, 0)';
        },
        { passive: true }
      );

      gallerySlider.addEventListener(
        'touchend',
        function(e) {
          if (!swipeTracking) return;
          swipeTracking = false;

          var touch = e.changedTouches && e.changedTouches[0];
          if (!touch) return;

          var deltaX = touch.clientX - swipeStartX;
          var deltaY = touch.clientY - swipeStartY;

          if (isDragging) {
            if (Math.abs(deltaX) >= swipeThreshold) {
              if (deltaX < 0) goNext();
              else goPrev();
            } else {
              goToDisplayIndex(displayIndex, true);
            }
          } else if (Math.abs(deltaX) >= swipeThreshold && Math.abs(deltaY) <= Math.abs(deltaX)) {
            if (deltaX < 0) goNext();
            else goPrev();
          }

          isDragging = false;
        },
        { passive: true }
      );

      gallerySlider.addEventListener(
        'touchcancel',
        function() {
          if (!swipeTracking) return;
          swipeTracking = false;
          isDragging = false;
          goToDisplayIndex(displayIndex, true);
        },
        { passive: true }
      );

      setTrackPosition(displayIndex, false);
      syncThumbs(0);
    }
  }

  var shareBtn = document.querySelector('.product__action-btn--share');
  if (shareBtn) {
    shareBtn.addEventListener('click', function() {
      var url = shareBtn.getAttribute('data-share-url');
      var title = shareBtn.getAttribute('data-share-title');
      if (!url) return;
      if (navigator.share) {
        navigator.share({ url: url, title: title || '' }).catch(function() {});
      } else {
        navigator.clipboard.writeText(url).then(function() {
          if (shareBtn.dataset.copied) return;
          shareBtn.dataset.copied = '1';
          var label = shareBtn.getAttribute('aria-label');
          shareBtn.setAttribute('aria-label', 'Link kopyalandı');
          setTimeout(function() {
            shareBtn.removeAttribute('data-copied');
            shareBtn.setAttribute('aria-label', label || 'Paylaş');
          }, 2000);
        }).catch(function() {});
      }
    });
  }

  var favoriteBtn = document.querySelector('[data-favorite-toggle]');
  if (favoriteBtn) {
    var favoriteToast = null;
    var favoriteToastMessage = null;
    var favoriteToastTimer = null;
    var favoriteIcon = favoriteBtn.querySelector('[data-favorite-icon]');
    var productId = favoriteBtn.getAttribute('data-product-id');
    var customerId = favoriteBtn.getAttribute('data-customer-id') || window.__LC_CUSTOMER_ID || '';
    var customerName = favoriteBtn.getAttribute('data-customer-name') || '';
    var customerFirstName = favoriteBtn.getAttribute('data-customer-first-name') || '';
    var customerLastName = favoriteBtn.getAttribute('data-customer-last-name') || '';
    var favoriteRecordId = '';
    var isFavorite = false;
    var isFavoriteBusy = false;

    function resolveFavoriteToastElements() {
      if (!favoriteToast || !favoriteToastMessage) {
        favoriteToast = document.getElementById('favorite-toast');
        favoriteToastMessage = favoriteToast ? favoriteToast.querySelector('[data-favorite-toast-message]') : null;
      }
      return !!(favoriteToast && favoriteToastMessage);
    }

    function showFavoriteToast(type) {
      if (!resolveFavoriteToastElements()) return;
      var enabledAttr = String(favoriteToast.getAttribute('data-enabled') || '').toLowerCase();
      var enabled = enabledAttr !== 'false' && enabledAttr !== '0';
      if (!enabled) return;
      var addText = favoriteToast.getAttribute('data-add-text') || '';
      var removeText = favoriteToast.getAttribute('data-remove-text') || '';
      var duration = parseInt(favoriteToast.getAttribute('data-duration'), 10);
      if (!duration || duration < 300) duration = 2400;
      favoriteToastMessage.textContent = type === 'remove' ? removeText : addText;
      favoriteToast.setAttribute('aria-hidden', 'false');
      favoriteToast.classList.add('is-visible');
      if (favoriteToastTimer) clearTimeout(favoriteToastTimer);
      favoriteToastTimer = setTimeout(function() {
        favoriteToast.classList.remove('is-visible');
        favoriteToast.setAttribute('aria-hidden', 'true');
      }, duration);
    }

    function setFavoriteState(active) {
      isFavorite = !!active;
      favoriteBtn.classList.toggle('is-active', !!active);
      favoriteBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var ariaActive = favoriteBtn.getAttribute('data-favorite-aria-active') || '';
      var ariaAdd = favoriteBtn.getAttribute('data-favorite-aria-add') || '';
      favoriteBtn.setAttribute('aria-label', active ? ariaActive : ariaAdd);
      if (!favoriteIcon) return;
      var defaultIcon = favoriteIcon.getAttribute('data-default-icon');
      var activeIcon = favoriteIcon.getAttribute('data-active-icon');
      favoriteIcon.src = active ? activeIcon : defaultIcon;
    }

    function getProductCandidateValues(item) {
      if (!item) return [];
      return [
        item.product_id,
        item.productId,
        item.product,
        item.product_gid,
        item.urun_id,
        item.product_numeric_id,
        item.product_handle
      ].filter(function(v) { return v !== null && v !== undefined && String(v).trim() !== ''; })
        .map(function(v) { return String(v); });
    }

    function itemMatchesProduct(item, currentProductId) {
      if (!item || !currentProductId) return false;
      var pid = String(currentProductId);
      var values = getProductCandidateValues(item);
      if (!values.length) return false;
      return values.some(function(value) {
        return value === pid || value.indexOf('/' + pid) !== -1;
      });
    }

    function getFavoriteRecordId(item) {
      if (!item) return '';
      var raw =
        item.id ||
        item.metafield_id ||
        item.metafieldId ||
        item.favorite_id ||
        item.favoriteId ||
        '';
      return String(raw || '').trim();
    }

    function parseFavoritesResponse(data) {
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.favorites)) return data.favorites;
      if (data && Array.isArray(data.data)) return data.data;
      return [];
    }

    function ensureLoggedInOrRedirect() {
      customerId = favoriteBtn.getAttribute('data-customer-id') || window.__LC_CUSTOMER_ID || '';
      customerName = favoriteBtn.getAttribute('data-customer-name') || customerName || '';
      customerFirstName = favoriteBtn.getAttribute('data-customer-first-name') || customerFirstName || '';
      customerLastName = favoriteBtn.getAttribute('data-customer-last-name') || customerLastName || '';
      if (customerId) return true;
      var returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = '/account/login?return_url=' + returnUrl;
      return false;
    }

    function loadFavoriteState() {
      if (!productId || !customerId) return Promise.resolve();
      var listUrl = '/apps/favorites?logged_in_customer_id=' + encodeURIComponent(customerId);
      return fetch(listUrl, { method: 'GET' })
        .then(function(response) {
          if (!response.ok) throw new Error('Favorite list failed');
          return response.json();
        })
        .then(function(data) {
          var list = parseFavoritesResponse(data);
          var matched = null;
          for (var i = 0; i < list.length; i++) {
            if (itemMatchesProduct(list[i], productId)) {
              matched = list[i];
              break;
            }
          }
          favoriteRecordId = matched ? getFavoriteRecordId(matched) : '';
          setFavoriteState(!!matched);
        })
        .catch(function() {});
    }

    function addFavorite() {
      var normalizedCustomerName = customerName;
      if (!normalizedCustomerName && (customerFirstName || customerLastName)) {
        normalizedCustomerName = (customerFirstName + ' ' + customerLastName).trim();
      }
      var payload = {
        customer_id: 'gid://shopify/Customer/' + customerId,
        product_id: 'gid://shopify/Product/' + productId,
        customer_name: normalizedCustomerName,
        customer_first_name: customerFirstName,
        customer_last_name: customerLastName
      };
      return fetch('/apps/favorites', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(function(response) {
        if (!response.ok) throw new Error('Favorite add failed');
      });
    }

    function removeFavorite() {
      if (!favoriteRecordId) {
        return loadFavoriteState().then(function() {
          if (!favoriteRecordId) throw new Error('Favorite record id not found');
        });
      }
      return fetch('/apps/favorites', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: favoriteRecordId
        })
      }).then(function(response) {
        if (!response.ok) throw new Error('Favorite delete failed');
      });
    }

    if (productId && customerId) loadFavoriteState();

    favoriteBtn.addEventListener('click', function () {
      if (isFavoriteBusy) return;
      if (!ensureLoggedInOrRedirect()) return;
      if (!productId) return;

      favoriteBtn.classList.remove('is-pressing');
      void favoriteBtn.offsetWidth;
      favoriteBtn.classList.add('is-pressing');
      favoriteBtn.addEventListener('animationend', function onEnd() {
        favoriteBtn.classList.remove('is-pressing');
        favoriteBtn.removeEventListener('animationend', onEnd);
      });

      isFavoriteBusy = true;
      var wasActive = isFavorite;

      setFavoriteState(!wasActive);
      showFavoriteToast(wasActive ? 'remove' : 'add');

      var actionPromise = wasActive ? removeFavorite() : addFavorite();
      actionPromise
        .then(function() {
          try {
            if (!wasActive && typeof window.__DL_trackWishlistAdd === 'function') {
              window.__DL_trackWishlistAdd();
            }
          } catch (eDl) {}
          if (wasActive) {
            favoriteRecordId = '';
          } else {
            loadFavoriteState();
          }
        })
        .catch(function() {
          setFavoriteState(wasActive);
        })
        .finally(function() {
          isFavoriteBusy = false;
        });
    });
  }

  function initProductStickyAtc() {
    var mq = window.matchMedia('(max-width: 1023px)');
    var form = document.querySelector('.product .product__form[data-ajax-cart]');
    var anchor = form && form.querySelector('[data-atc-anchor]');
    var sticky = document.querySelector('[data-product-sticky-atc]');
    if (!form || !anchor || !sticky) return;

    var mainQty = form.querySelector('.product__quantity-input');
    var stickyQty = sticky.querySelector('[data-sticky-qty-input]');
    var stickyMinus = sticky.querySelector('[data-sticky-qty-minus]');
    var stickyPlus = sticky.querySelector('[data-sticky-qty-plus]');
    var mainSubmit = form.querySelector('button[name="add"][type="submit"]');
    var stickySubmit = sticky.querySelector('[data-sticky-submit]');
    var mainBtnText = form.querySelector('.product__add-btn-text');
    var stickyBtnText = sticky.querySelector('.product__add-btn-text');
    var footerBoundary = null;
    var ioAnchor = null;
    var scrollTick = false;
    var anchorPast = false;

    function syncQtyToSticky() {
      if (!mainQty || !stickyQty) return;
      stickyQty.value = mainQty.value;
    }

    function bumpMainQty(delta) {
      if (!mainQty) return;
      var val = parseInt(mainQty.value, 10) || 1;
      var next = val + delta;
      if (next < 1) next = 1;
      if (next > 99) next = 99;
      mainQty.value = String(next);
      mainQty.dispatchEvent(new Event('input', { bubbles: true }));
      mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      syncQtyToSticky();
    }

    function syncButtonFromMain() {
      if (mainSubmit && stickySubmit) {
        stickySubmit.disabled = mainSubmit.disabled;
        var style = mainSubmit.getAttribute('style');
        if (style) stickySubmit.setAttribute('style', style);
        else stickySubmit.removeAttribute('style');
      }
      if (mainBtnText && stickyBtnText && mainSubmit && mainSubmit.getAttribute('aria-busy') !== 'true') {
        stickyBtnText.textContent = mainBtnText.textContent;
      }
    }

    function setStickyVisible(show) {
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function resolveFooterBoundary() {
      footerBoundary =
        document.querySelector('[data-sticky-atc-footer-boundary]') ||
        document.querySelector('.footer__top') ||
        document.querySelector('footer.footer');
    }

    function isFooterReached() {
      if (!footerBoundary) return false;
      var stickyH = sticky.offsetHeight || 72;
      var top = footerBoundary.getBoundingClientRect().top;
      return top <= window.innerHeight - stickyH;
    }

    function updateStickyVisibility() {
      if (!mq.matches) {
        setStickyVisible(false);
        return;
      }
      var show = anchorPast && !isFooterReached();
      setStickyVisible(show);
      if (show) syncButtonFromMain();
    }

    function measureOnScroll() {
      if (!scrollTick) {
        scrollTick = true;
        requestAnimationFrame(function() {
          scrollTick = false;
          if (!footerBoundary) resolveFooterBoundary();
          updateStickyVisibility();
        });
      }
    }

    function bindObserver() {
      if (ioAnchor) return;
      resolveFooterBoundary();

      ioAnchor = new IntersectionObserver(
        function(entries) {
          var entry = entries[0];
          anchorPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          updateStickyVisibility();
        },
        { threshold: 0 }
      );
      ioAnchor.observe(anchor);

      window.addEventListener('scroll', measureOnScroll, { passive: true });
      window.addEventListener('resize', measureOnScroll, { passive: true });
      measureOnScroll();
    }

    function teardownObserver() {
      if (ioAnchor) {
        ioAnchor.disconnect();
        ioAnchor = null;
      }
      window.removeEventListener('scroll', measureOnScroll);
      window.removeEventListener('resize', measureOnScroll);
      anchorPast = false;
      setStickyVisible(false);
    }

    function onMqChange() {
      if (mq.matches) {
        syncQtyToSticky();
        syncButtonFromMain();
        bindObserver();
      } else {
        teardownObserver();
      }
    }

    if (mainQty) {
      mainQty.addEventListener('input', syncQtyToSticky);
      mainQty.addEventListener('change', syncQtyToSticky);
    }

    if (stickyMinus) {
      stickyMinus.addEventListener('click', function() {
        bumpMainQty(-1);
      });
    }
    if (stickyPlus) {
      stickyPlus.addEventListener('click', function() {
        bumpMainQty(1);
      });
    }

    if (stickySubmit && mainSubmit) {
      stickySubmit.addEventListener('click', function() {
        if (mainSubmit.disabled) return;
        mainSubmit.click();
      });
    }

    if (mainSubmit) {
      var mo = new MutationObserver(syncButtonFromMain);
      mo.observe(mainSubmit, { attributes: true, attributeFilter: ['disabled', 'aria-busy', 'style'] });
    }
    if (mainBtnText) {
      var textMo = new MutationObserver(syncButtonFromMain);
      textMo.observe(mainBtnText, { characterData: true, childList: true, subtree: true });
    }

    form.addEventListener('product:atc-busy', function(e) {
      var detail = (e && e.detail) || {};
      if (!stickySubmit || !stickyBtnText) return;
      if (detail.busy) {
        stickySubmit.disabled = true;
        stickySubmit.setAttribute('aria-busy', 'true');
        if (detail.addingText) stickyBtnText.textContent = detail.addingText;
      } else {
        stickySubmit.removeAttribute('aria-busy');
        syncButtonFromMain();
      }
    });

    syncQtyToSticky();
    syncButtonFromMain();
    onMqChange();
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onMqChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onMqChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductStickyAtc);
  } else {
    initProductStickyAtc();
  }

  window.__lcLockBodyScroll = function() {
    _lockScroll();
  };
  window.__lcUnlockBodyScroll = function() {
    _unlockScroll();
  };
})();
